module.exports = __webpack_public_path__ + "img/mb-visual-background.36625153.png";